import {
    Component, Input,
    ChangeDetectionStrategy, ViewEncapsulation, HostBinding,
} from '@angular/core';
import { BaseDirective } from '../../base.directive';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    selector: 'eui-block-document',
    templateUrl: './eui-block-document.component.html',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiBlockDocumentComponent extends BaseDirective {
    @Input()
    get isBlocked() { return this._isBlocked; }
    set isBlocked(value) { this._isBlocked = coerceBooleanProperty(value); }
    _isBlocked = false;

    @HostBinding('class')
    get cssClasses() {
        return [
            this.isBlocked ? `eui-block-document--blocked` : ``,
            super.getCssClasses('eui-block-document'),
        ].join(' ').trim();
    }

    constructor() {
        super();
    }

}
